import { VideoMediaEntity } from '@/pages/AdvancedEditor/components/panels/media/types';
import styled from '@emotion/styled';
import { useRef } from 'react';
import { DeleteButton, InfoTag, Loader, TileContainer, TileTitle } from './common';

const StyledVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

interface Props {
    entity: VideoMediaEntity;
    width: number;
    height: number;
    onDelete: () => Promise<void>;
    onClick: () => void;
}

export const VideoTile = ({ entity, width, height, onDelete, onClick }: Props) => {
    const videoDuration = entity.duration && new Date(entity.duration * 1000).toISOString().substring(14, 19);

    const videoRef = useRef<HTMLVideoElement>(null);

    const handleMouseEnter = () => {
        if (!entity.isLoading && videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleMouseLeave = () => {
        if (!entity.isLoading && videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0; // Reset video to the start
        }
    };

    return (
        <TileContainer width={width} height={height} onClick={entity.isLoading ? undefined : onClick} isLoading={entity.isLoading}>
            {entity.isLoading && <Loader />}
            <DeleteButton className="only-hover" onClick={onDelete} />
            <TileTitle className="only-hover">{entity.filename}</TileTitle>
            <InfoTag content={videoDuration} />

            <StyledVideo
                ref={videoRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                src={entity.src}
                poster={entity.thumbnail}
                muted
                loop
            />
        </TileContainer>
    );
};
